import React from "react";
import styles from "./PdfFooter.module.css";
// Image is loaded from the public folder
const addImage = "/assets/addImage.png";

const PdfFooter: React.FC = () => {
  return (
    <div className={styles.footerContent}>
      <div className={styles.advertisementHeader}>
        <span>ADVERTISEMENT</span>
      </div>

      <div className={styles.adContainer}>
        <img
          src={addImage}
          alt="Advertisement"
          className={styles.adImage}
        />
      </div>


    </div>

  );
};

export default PdfFooter;
